import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getRequests as getRequestsApi,
  addNewRequest as addNewRequestApi,
  updateRequest as updateRequestApi,
  deleteRequest as deleteRequestApi,
} from "../../helpers/realbackend_helper";

export const getRequests = createAsyncThunk(
  "userRequest/getRequests",
  async () => {
    try {
      const response = await getRequestsApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewRequest = createAsyncThunk(
  "userRequest/addNewRequest",
  async (request) => {
    try {
      const response = addNewRequestApi(request);
      toast.success("Хүсэлт амжилттай илгээгдлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Хүсэлт илгээхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateRequest = createAsyncThunk(
  "userRequest/updateRequest",
  async (request) => {
    try {
      const response = updateRequestApi(request);
      toast.success("Хүсэлт амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Хүсэлт засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteRequest = createAsyncThunk(
  "userRequest/deleteRequest",
  async (id, { rejectWithValue }) => {
    try {
      await deleteRequestApi(id);

      toast.success("Хүсэлт амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Хүсэлт устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);
